import RichText from "../rich-text";

const ListItem = ({ content }) => (
  <li>
    <RichText content={content} />
  </li>
);

export default ListItem;
